import { jwtDecode } from 'jwt-decode';

export async function sha256(message) {
    // encode as UTF-8
    message = message.toLowerCase();
    const msgBuffer = new TextEncoder().encode(message.toLowerCase());
    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

 export  const clearIRISCookies = () => {
		const cookies = document.cookie.split(';');
		for (let cookie of cookies) {
			const eqPos = cookie.indexOf('=');
			const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
			if (name.indexOf('IRIS_') >= 0) {
				document.cookie = name +'=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname;
				document.cookie = name +'=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;samesite=strict'
			}
		}
	};

	export const revokeIRISToken = async () => {
    const apiBaseURL = process.env.API_BASE_URL;
		try {
			const auth_token = getIIRISCookie('IRIS_AUTH');
			const refresh_token = getIIRISCookie('IRIS_HASH');
      const decodedToken = jwtDecode(auth_token);
      const client_id =  decodedToken.client_id;

			const response = await fetch(apiBaseURL + '/v3/authorization/revokeToken', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${auth_token}`
				},
				body: JSON.stringify({
					refresh_token: refresh_token,
					client_id:client_id
				})
			});

			if (response.ok) {
				console.log('Logout successful');
			} else {
				console.error('Logout failed');
			}
		} catch (error) {
			console.error('Error while logging out:', error);
		}

	}
  export const logOutSession = async () => {
    localStorage.removeItem('CheckLocalUser');
		localStorage.removeItem('auth_flow');
		localStorage.removeItem('iiris_ust');
		localStorage.removeItem("audience_profile");
		localStorage.removeItem("audience_consent");
    if(getIIRISCookie('IRIS_HASH')) {
  		await revokeIRISToken();
    } 
		clearIRISCookies();
		if (window.irisLogoutCallback) {
			const logoutObj = { "success": true };
			window.irisLogoutCallback(logoutObj)
		}
		document.cookie = 'IDENTITY_LOCALE=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname;
  }

  export function getIIRISCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  
  export async function getCognitoUser(idToken){
    if(idToken === '') return null;
    const user = {};
    const userAttributes = ["custom:country", "sub", "email_verified", "given_name", "custom:terms", "family_name", "email", "identities", "name", "picture", "custom:business_email"]
    try {
      const decodedToken = jwtDecode(idToken);
      userAttributes.forEach(attribute => {
        user[attribute] = typeof decodedToken[attribute] === 'object' ? JSON.stringify(decodedToken[attribute]) : decodedToken[attribute];
      })
    } catch (err){
      console.log(err);
      return null;
    }
    return user;
  }